// src/pages/PaymentSuccess.js
import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";


const API_URL = "https://api.kupto.co/api";

const PaymentSuccess = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const [loading, setLoading] = useState(true);
  const [message, setMessage] = useState("Verifying your payment...");

  useEffect(() => {
    const verifyPayment = async () => {
      // Try URL first, fallback to localStorage
      

        const orderId =
          searchParams.get("orderId") ||
          searchParams.get("CompanyRef") ||
          localStorage.getItem("kupto_dpo_order_id");


     

      const token =
        searchParams.get("TransToken") ||
        searchParams.get("token") ||
        localStorage.getItem("kupto_dpo_token");

      if (!orderId || !token) {
        toast.error("Missing payment verification details.");
        navigate("/my-orders", { replace: true });
        return;
      }

      try {
        setLoading(true);
        setMessage("Verifying your payment...");

        const res = await axios.post(
          `${API_URL}/dpo/verify-token`,
          {
            orderId,
            token,
          },
          {
            withCredentials: true,
          }
        );

        // ✅ Clean up after success
        localStorage.removeItem("kupto_dpo_token");
        localStorage.removeItem("kupto_dpo_order_id");

        // ✅ Save for ThankYou page
        localStorage.setItem(
          "lastCompletedOrder",
          JSON.stringify(res.data)
        );

        toast.success(
          res?.data?.message || "Payment verified successfully"
        );

        // ✅ Redirect to Thank You page
        navigate("/thank-you", {
          replace: true,
          state: {
            completedOrder: res.data,
          },
        });
      } catch (err) {
        console.error("DPO payment verification failed:", err);

        const errorMsg =
          err?.response?.data?.message ||
          "Payment could not be verified. Please check your order status.";

        toast.error(errorMsg);
        setMessage(errorMsg);

        // ❗ Send user to orders instead of breaking flow
        navigate("/my-orders", { replace: true });
      } finally {
        setLoading(false);
      }
    };

    verifyPayment();
  }, [navigate, searchParams]);

  return (
    <div
      style={{
        minHeight: "70vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: 20,
        textAlign: "center",
      }}
    >
      <div>
        <h2>
          {loading ? "Please wait..." : "Payment Verification"}
        </h2>
        <p>{message}</p>
      </div>
    </div>
  );
};

export default PaymentSuccess;